export const strings = {
  title: 'Chance & Change',
  tagline: 'Flip. Place. Capture. Conquer.',
  modes: {
    local: { title: 'Pass & Play', blurb: 'Two players, one screen.' },
    online: { title: 'Play Online', blurb: 'Invite a friend with a link.' },
    ai: { title: 'vs Computer', blurb: 'Face Penny, Nick, or Quinn.' },
  },
  errors: {
    missingRoom: "That room doesn't exist (anymore).",
    fullRoom: 'This game is already full.',
    disconnected: 'Connection lost — trying to reconnect…',
  },
  coach: {
    oneMatch: '1 match — place 1 coin and move a stack (any order).',
    noMatches: 'No matches — capture a coin and move a stack (any order).',
  },
} as const;
